import { forwardRef } from "react";

import { Icon, IconProps } from "../icon";

export type UserSolidIconProps = IconProps;

export const UserSolidIcon = forwardRef<SVGSVGElement, UserSolidIconProps>(
  function UserSolidIcon(props: UserSolidIconProps, ref) {
    return (
      <Icon
        data-testid="UserSolidIcon"
        aria-label="user solid"
        viewBox="0 0 12 12"
        ref={ref}
        {...props}
      >
        <path d="M12 12v-.996c0-.453-.137-.856-.41-1.207a1.958 1.958 0 0 0-1.019-.715 3.868 3.868 0 0 0-.328-.117 10.592 10.592 0 0 0-.422-.129c-.039-.008-.086-.02-.141-.035s-.129-.039-.223-.07c-.07-.016-.137-.031-.199-.047a1.538 1.538 0 0 0-.164-.059c-.523-.156-.918-.336-1.184-.539s-.43-.465-.492-.785c.234-.242.449-.531.645-.867s.359-.695.492-1.078a7.61 7.61 0 0 0 .328-1.172C8.961 3.778 9 3.383 9 3c0-.547-.078-1.012-.234-1.395S8.395.914 8.121.679a2.401 2.401 0 0 0-.949-.516C6.805.054 6.414-.001 6-.001s-.805.055-1.172.164a2.389 2.389 0 0 0-1.594 1.442C3.077 1.988 3 2.453 3 3c0 .383.039.777.117 1.184.078.398.188.789.328 1.172.133.383.297.742.492 1.078s.41.625.645.867c-.062.32-.227.582-.492.785s-.66.383-1.184.539a1.346 1.346 0 0 0-.164.059c-.062.016-.129.031-.199.047-.094.031-.168.055-.223.07s-.102.027-.141.035c-.164.047-.305.09-.422.129a3.868 3.868 0 0 0-.328.117 1.96 1.96 0 0 0-1.02.715c-.273.352-.41.754-.41 1.207V12h12z" />
      </Icon>
    );
  }
);
